/**
 * وظائف مساعدة لمعالجة الصور
 */

/**
 * تحويل ملف إلى صيغة Base64
 * @param file ملف الصورة المراد تحويله
 * @returns وعد بسلسلة Base64
 */
export const convertToBase64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const result = reader.result as string;

      // التأكد من أن البيانات بالصيغة الصحيحة (data:image/jpeg;base64,...)
      if (typeof result === 'string' && result.startsWith('data:')) {
        console.log('تم تحويل الصورة بنجاح إلى Base64');
        resolve(result);
      } else {
        // إذا لم تكن البيانات بالصيغة الصحيحة
        console.error('البيانات المُحولة ليست بالصيغة المتوقعة');
        reject(new Error('فشل في تحويل الصورة إلى Base64'));
      }
    };

    reader.onerror = () => {
      console.error('حدث خطأ أثناء قراءة الملف');
      reject(new Error('فشل في قراءة ملف الصورة'));
    };

    reader.readAsDataURL(file);
  });
};

/**
 * تحويل URL صورة إلى ملف Blob
 * @param url عنوان URL للصورة
 * @returns وعد بملف Blob
 */
export const urlToBlob = async (url: string): Promise<Blob> => {
  try {
    // إذا كان URL هو Base64، قم بتحويله مباشرة
    if (url.startsWith('data:')) {
      const response = await fetch(url);
      return await response.blob();
    }

    // إذا كان URL عادياً، قم بتنزيل الصورة
    const response = await fetch(url);
    return await response.blob();
  } catch (error) {
    console.error('Error converting URL to Blob:', error);
    throw error;
  }
};

/**
 * تحويل Blob إلى ملف
 * @param blob ملف Blob
 * @param fileName اسم الملف
 * @returns ملف File
 */
export const blobToFile = (blob: Blob, fileName: string): File => {
  return new File([blob], fileName, { type: blob.type });
};

/**
 * تحويل URL صورة إلى ملف
 * @param url عنوان URL للصورة
 * @param fileName اسم الملف
 * @returns وعد بملف File
 */
export const urlToFile = async (url: string, fileName: string): Promise<File> => {
  const blob = await urlToBlob(url);
  return blobToFile(blob, fileName);
};

export default {
  convertToBase64,
  urlToBlob,
  blobToFile,
  urlToFile
};